import { RootState } from '../index'

export const selectCentralModalDialogFirstMessage = (state: RootState) =>
  state.centralModalDialog[0]
